import moment from 'moment';

import {SearchResult, SearchResultType} from 'common/report/util/search/types';
import {ContentType, Dashboard, MediaCardType} from 'common/report/dashboards/types';
import {ChartType} from 'common/report/constants';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';

export const entityData: SearchResult[] = [
  {
    description: ``,
    id: 1,
    last_edited: `2020-06-10T08:41:50`,
    link: `/report/3/insights/#report/1`,
    name: `Test Bookmark 1`,
    report: `insights`,
    scores: {final: 50, popularity: 100},
    type: SearchResultType.Report,
    unique_count: 100,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    presence_views: [
      {
        user: {
          id: 789,
          email: `bobsmith@example.com`,
          name: `Bob Smith`,
        },
        timestamp: 1647915600,
      },
      {
        user: {
          id: 123,
          email: `johndoe@example.com`,
          name: `John Doe`,
        },
        timestamp: 1647919200,
      },
    ],
    shared_with_user: true,
  },
  {
    chart_type: ChartType.Line,
    description: `Description`,
    id: 2,
    last_edited: `2020-06-08T08:41:50`,
    link: `/report/3/insights/#report/2`,
    name: `Test Bookmark 2`,
    report: `insights`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 200,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    presence_views: [],
    shared_with_user: true,
  },
  {
    description: ``,
    id: 3,
    last_edited: `2020-06-07T08:41:50`,
    link: `/report/3/insights/#report/3`,
    name: `Test Bookmark 3`,
    report: `insights`,
    scores: {final: 50, popularity: 51},
    type: SearchResultType.Report,
    unique_count: 300,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    presence_views: [],
    shared_with_user: true,
  },
  {
    description: ``,
    id: 4,
    last_edited: `2020-06-06T08:41:50`,
    link: `/report/3/funnels/#report/4`,
    name: `Test Bookmark 4`,
    report: `funnels`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 400,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    presence_views: [],
    shared_with_user: true,
  },
  {
    description: ``,
    id: 5,
    last_edited: `2020-06-03T08:41:50`,
    link: `/report/3/retention/#report/5`,
    name: `Test Bookmark 5`,
    report: `retention`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 500,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    presence_views: [],
    shared_with_user: true,
  },
];

export const getEntityDataMany: (amount: number) => SearchResult[] = (amount: number) => {
  const data = [];

  for (let i = 1; i <= amount; i++) {
    data.push({
      description: ``,
      id: i,
      last_edited: `2020-06-03T08:41:50`,
      link: `/report/3/retention/#report/5`,
      name: `Test Bookmark 5`,
      report: `retention`,
      scores: {final: 50, popularity: 50},
      type: SearchResultType.Report,
      unique_count: 500,
      user: `User 2`,
      user_id: 2,
      email: `user2@hotmail.com`,
      created: `2020-03-29T22:07:44`,
      presence_views: [],
    });
  }

  return data;
};

export const dashboardEntities: SearchResult[] = [
  {
    description: `Questions relating to use of data classification features.`,
    id: 1,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=1`,
    name: `Test Dashboard 1`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    shared_with_user: true,
    presence_views: [],
    thumbnail_layout: {
      rows: {
        r1: {
          height: 0,
          cells: [
            {
              id: `c1`,
              content_id: `1`,
              content_type: ContentType.Report,
              width: 3,
            },
            {
              id: `c2`,
              content_id: `2`,
              content_type: ContentType.Text,
              width: 6,
            },
            {
              id: `c3`,
              content_id: `3`,
              content_type: ContentType.Media,
              width: 3,
            },
          ],
        },
      },
      version: `2.0.0`,
      order: [`r1`],
    },
    thumbnail_contents: {
      [ContentType.Report]: {1: {chart_type: ChartType.Line, bookmark_type: BookmarkType.Insights}},
      [ContentType.Text]: {2: null},
      [ContentType.Media]: {3: {media_type: MediaCardType.Image, path: `some-path`}},
    },
  },
  {
    description: `Test Dashboard 2 description hey!`,
    id: 89812,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=89812`,
    name: `Test Dashboard 2`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    shared_with_user: true,
    presence_views: [
      {
        user: {
          id: 456,
          email: `janedoe@example.com`,
          name: `Jane Doe`,
        },
        timestamp: 1647922800,
      },
      {
        user: {
          id: 101112,
          email: `sarahlee@example.com`,
          name: `Sarah Lee`,
        },
        timestamp: 1647930000,
      },
      {
        user: {
          id: 131415,
          email: `michaelnguyen@example.com`,
          name: `Michael Nguyen`,
        },
        timestamp: 1647933600,
      },
    ],
  },
  {
    description: `Test Dashboard 3 description hey!`,
    id: 89812123,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=89812123`,
    name: `Test Dashboard 3`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
    created: `2020-03-29T22:07:44`,
    shared_with_user: true,
    presence_views: [],
  },
];

export const dashboardsRaw: Dashboard[] = dashboardEntities.map((entity) => ({
  id: entity.id,
  title: entity.name,
  description: entity.description,
  is_private: false,
  cards: [],
  time_filter: {},
  filters: [],
  card_order: [],
  creator: entity.user,
  creator_id: entity.user_id,
  creator_name: entity.user,
  creator_email: entity.email,
  layout: {},
  contents: {},
  is_restricted: true,
  modified: moment(entity.last_edited).format(`YYYY-MM-DD`),
  can_update_basic: true,
  can_view: true,
  allow_staff_override: false,
  is_superadmin: false,
  can_share: false,
}));
